import { ActionCreator } from '@ardoq/rxbeach';

/**
 * Assert that all action creators are functions, and throw if not.
 * Intended purely to be used in a development environment in order to provide
 * better error messages and stack traces if any of the action creators are
 * undefined (which could happen on renaming).
 */
export const assertAllActionCreatorsAreValid = (
  actionCreators: ActionCreator[]
) => {
  for (const actionCreator of actionCreators) {
    if (!actionCreator || typeof actionCreator !== 'function') {
      const message =
        'Invalid action creator found in the postMessageBridge config';
      throw new Error(message);
    }
  }
};
